import { FaClock, FaTimes } from "react-icons/fa"
import SearchIcon from "@mui/icons-material/Search"
import { Button } from "@mui/material"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import { getStartAndEndOfMonth } from "../utils/GetDates"
import React from "react"
import { FormatDateString } from "../utils/FormatDate"
import { GetDynamicColor } from "../utils/GetTextColor"
import { useSelector } from "react-redux"
import { ResponsiveBar } from '@nivo/bar'
import { ResponsivePie } from '@nivo/pie'
import { ResponsiveSunburst } from '@nivo/sunburst'
import CheckBox from "../components/ui/components/CheckBox"

const DashboardActividadesComercialHora = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" 
  const selectedUserForAdmin = !isAdmin ? user.id : ""

  const [loadingStatus, setLoadingStatus] = useState(false);

  const [events, setEvents] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [valoresKPIs, setValoresKPIs] = useState([]);
  const [workerKPIs, setWorkerKPIs] = useState({});

  const [view, setView] = useState("chart")
  const [showCompleteHours, setShowCompleteHours] = useState(false)

  const eventosLlamadas = events.filter(event => event.eventType === "Llamada")
  const eventosMeets = events.filter(event => event.eventType === "Google Meet")
  const eventosEntradas = events.filter(event => event.eventType === "Entrada al sistema")
  const eventosCotizaciones = events.filter(event => event.eventType === "Cambio estado cotización")

  const [totalPages, setTotalPages] = useState(0);
  const [totalDocs, setTotalDocs] = useState(0);

  const [searchCriteria, setSearchCriteria] = useState("leadName");
  const [leadName, setLeadName] = useState("");

  const [eventType, setEventType] = useState("");
  const [eventSubType, setEventSubType] = useState("");

  const [leadStatus, setLeadStatus] = useState("");
  const [selectedSeller, setSelectedSeller] = useState("");

  const { start, end } = getStartAndEndOfMonth()
  
  // Ajustar las fechas para que incluyan todo el día
  const [startDate, setStartDate] = useState(() => {
    const date = new Date(start);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
  });
  
  const [endDate, setEndDate] = useState(() => {
    const date = new Date(end);
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString();
  });

  const ColorMapKPIs = [
    { min: 0, max: 25, color: "text-red-500" },
    { min: 25, max: 50, color: "text-yellow-400" },
    { min: 50, max: 75, color: "text-green-500" },
    { min: 75, max: 1000, color: "text-blue-500" }
  ];

  const getEvents = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/eventosLeads?limit=0`

      let andFilters = [];

      if (eventType) {
        url += `&where[eventType][equals]=${eventType}`
      }
      if (eventSubType) {
        url += `&where[eventSubType][equals]=${eventSubType}`
      }
      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }
      if (leadName) {
        console.log(leadName)
        if (searchCriteria === "leadName") {
          url += `&where[lead.leadName][like]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[lead.phone][like]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[lead.dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[lead][equals]=${leadName}`
        }
      }
      if (leadStatus) {
        url += `&where[lead.status][equals]=${leadStatus}`
      }
      if (selectedSeller) {
        url += `&where[seller][equals]=${selectedSeller}`
      }
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url);

      setEvents(response.data.docs);

      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      return false
    } finally {
      setLoadingStatus(false)
    }
  }

  const getSellers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?depth=0&limit=0&where[activo][equals]=true&where[area][equals]=Comercial`);
      setSellers(response.data.docs);
    } catch (error) {
      toast.error("No se pudieron obtener los vendedores: " + error)
    }
  }

  const getValoresKPIs = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/reglasValoresKPIs?limit=0`)
      setValoresKPIs(response.data.docs)
    } catch (e) {
      toast.error("No se pudieron obtener los valores de los KPIs: " + e)
    }
  }

  const handleResetSearch = () => {
    setLeadName("")
  }

  const handleSearchClients = () => {
    getEvents()
  }

  useEffect(() => {
    getEvents();
    getSellers();
    getValoresKPIs();
  }, []);

  useEffect(() => {
    getEvents();
  }, [leadStatus, selectedSeller, startDate, endDate, eventType, eventSubType]);

  useEffect(() => {
    if (events.length > 0 && valoresKPIs.length > 0) {
      // Calcular KPIs por trabajador
      const kpisPorTrabajador = events.reduce((acc, event) => {
        const sellerId = event.seller?.id;
        if (!sellerId) return acc;

        // Obtener el valor del KPI para este evento
        const valorKPI = valoresKPIs.find(kpi => kpi.subestado === event.eventSubType)?.valor || 0;

        // Sumar al acumulado del trabajador
        acc[sellerId] = (acc[sellerId] || 0) + valorKPI;

        return acc;
      }, {});

      setWorkerKPIs(kpisPorTrabajador);
    }
  }, [events, valoresKPIs]);

  useEffect(() => {
    if (leadName === "") {
      getEvents(); 
    }
  }, [leadName]);

  const ColorMap = {
    "Lead": "text-yellow-400",
    "Prospecto": "text-blue-500",
    "Cliente": "text-green-500",
  }

  // Agrupar eventos por vendedor y luego por hora
  const groupedEventsBySellerAndHour = events.filter(event => event.seller?.area !== "Administracion").reduce((acc, event) => {
    // Si no hay vendedor, usar un ID y nombre por defecto
    const sellerId = event.seller?.id || 'sin-vendedor';
    const sellerName = event.seller?.name || 'Sin vendedor asignado';
    const date = new Date(event.createdAt);
    const hour = date.getHours();
    const dayKey = date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    
    if (!acc[sellerId]) {
      acc[sellerId] = {
        name: sellerName,
        days: {}
      };
    }
    
    if (!acc[sellerId].days[dayKey]) {
      acc[sellerId].days[dayKey] = {
        date: date,
        hours: {}
      };
    }
    
    if (!acc[sellerId].days[dayKey].hours[hour]) {
      acc[sellerId].days[dayKey].hours[hour] = [];
    }
    
    acc[sellerId].days[dayKey].hours[hour].push(event);
    return acc;
  }, {});

  // Crear un array plano de todas las combinaciones día-hora-vendedor
  const allCombinations = Object.entries(groupedEventsBySellerAndHour).flatMap(([sellerId, sellerData]) => {
    return Object.entries(sellerData.days).flatMap(([dayKey, dayData]) => {
      return Object.keys(dayData.hours).map(hour => ({
        sellerId,
        sellerName: sellerData.name,
        date: dayData.date,
        hour: Number(hour),
        events: dayData.hours[hour]
      }));
    });
  });

  // Ordenar primero por fecha, luego por hora y finalmente por nombre del vendedor
  const sortedCombinations = allCombinations.sort((a, b) => {
    // Primero comparar por fecha (más reciente primero)
    const dateComparison = b.date.getTime() - a.date.getTime();
    if (dateComparison !== 0) return dateComparison;
    
    // Si es la misma fecha, comparar por hora
    if (a.hour !== b.hour) {
      return b.hour - a.hour;
    }
    
    // Si es la misma hora, ordenar por nombre del vendedor
    return a.sellerName.localeCompare(b.sellerName);
  });

  // Preparar datos para el gráfico  Eventos por Hora
  const prepareChartData = () => {
    const hours = Array.from({ length: showCompleteHours ? 24 : 18 }, (_, i) => `${showCompleteHours ? i : i + 6}:00`);
    const sellers = Object.keys(groupedEventsBySellerAndHour);
    
    return hours.map(hour => {
      const hourNum = parseInt(hour);
      const data = {
        hora: hour,
      };

      sellers.forEach(sellerId => {
        const sellerData = groupedEventsBySellerAndHour[sellerId];
        let totalEvents = 0;
        
        // Sumar eventos de todas las fechas para esta hora
        Object.values(sellerData.days).forEach(day => {
          if (day.hours[hourNum]) {
            totalEvents += day.hours[hourNum].length;
          }
        });
        
        data[sellerData.name] = totalEvents;
      });

      return data;
    });
  };

  // Preparar datos para el gráfico Eventos por Día de la Semana
  const prepareChartDataByDay = () => {
    const daysOfWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const sellers = Object.keys(groupedEventsBySellerAndHour);
    
    return daysOfWeek.map(dayName => {
      const data = {
        dia: dayName,
      };

      sellers.forEach(sellerId => {
        const sellerData = groupedEventsBySellerAndHour[sellerId];
        let totalEvents = 0;
        
        // Sumar eventos para este día de la semana
        Object.values(sellerData.days).forEach(day => {
          const dayOfWeek = day.date.getDay();
          if (daysOfWeek[dayOfWeek] === dayName) {
            // Sumar todos los eventos de todas las horas de este día
            Object.values(day.hours).forEach(hourEvents => {
              totalEvents += hourEvents.length;
            });
          }
        });
        
        data[sellerData.name] = totalEvents;
      });

      return data;
    });
  };

  // Preparar datos para el gráfico Eventos por tipo
  const preparePieData = () => {
    const eventTypes = {
      "Llamada": 0,
      "Google Meet": 0,
      "Entrada al sistema": 0,
      "Cambio estado cotización": 0
    };

    events.forEach(event => {
      if (eventTypes.hasOwnProperty(event.eventType)) {
        eventTypes[event.eventType]++;
      }
    });

    return Object.entries(eventTypes).map(([id, value]) => ({
      id,
      label: id,
      value,
      color: id === "Llamada" ? "#e41a1c" :
             id === "Google Meet" ? "#377eb8" :
             id === "Entrada al sistema" ? "#4daf4a" :
             "#ff7f00"
    }));
  };

  // Preparar datos para el gráfico Eventos por Tipo y Subtipo
  const prepareEventSubtypesData = () => {
    const data = {
      id: "Eventos",
      children: [
        {
          id: "Llamada",
          children: [
            {
              id: "Llamada perdida",
              value: events.filter(e => e.eventSubType === "Llamada perdida").length
            },
            {
              id: "Llamada corta",
              value: events.filter(e => e.eventSubType === "Llamada corta").length
            },
            {
              id: "Llamada fria",
              value: events.filter(e => e.eventSubType === "Llamada fria").length
            },
            {
              id: "Llamada atendida",
              value: events.filter(e => e.eventSubType === "Llamada atendida").length
            }
          ]
        },
        {
          id: "Google Meet",
          children: [
            {
              id: "Meet cancelado",
              value: events.filter(e => e.eventSubType === "Meet cancelado").length
            },
            {
              id: "Meet reagendado",
              value: events.filter(e => e.eventSubType === "Meet reagendado").length
            },
            {
              id: "Meet agendado",
              value: events.filter(e => e.eventSubType === "Meet agendado").length
            },
            {
              id: "Meet atendido",
              value: events.filter(e => e.eventSubType === "Meet atendido").length
            }
          ]
        },
        {
          id: "Entrada al sistema",
          children: [
            {
              id: "Entrada al sistema",
              value: events.filter(e => e.eventType === "Entrada al sistema").length
            }
          ]
        },
        {
          id: "Cambio estado cotización",
          children: [
            {
              id: "Exito",
              value: events.filter(e => e.eventSubType === "Exito").length
            },
            {
              id: "Evaluando opciones",
              value: events.filter(e => e.eventSubType === "Evaluando opciones").length
            },
            {
              id: "Para el futuro",
              value: events.filter(e => e.eventSubType === "Para el futuro").length
            },
            {
              id: "Frio",
              value: events.filter(e => e.eventSubType === "Frio").length
            },
            {
              id: "Por confirmar depósito",
              value: events.filter(e => e.eventSubType === "Por confirmar depósito").length
            },
            {
              id: "Curioso",
              value: events.filter(e => e.eventSubType === "Curioso").length
            },
            {
              id: "No responde",
              value: events.filter(e => e.eventSubType === "No responde").length
            },
            {
              id: "El servicio le parece caro",
              value: events.filter(e => e.eventSubType === "El servicio le parece caro").length
            },
            {
              id: "Decidió trabajar con otra agencia",
              value: events.filter(e => e.eventSubType === "Decidió trabajar con otra agencia").length
            },
            {
              id: "Decidió trabajar con un freelancer",
              value: events.filter(e => e.eventSubType === "Decidió trabajar con un freelancer").length
            },
            {
              id: "No esta en mi ciudad",
              value: events.filter(e => e.eventSubType === "No esta en mi ciudad").length
            },
            {
              id: "Competencia o sospechoso",
              value: events.filter(e => e.eventSubType === "Competencia o sospechoso").length
            },
            {
              id: "Lead con poco presupuesto",
              value: events.filter(e => e.eventSubType === "Lead con poco presupuesto").length
            }
          ]
        }
      ]
    };
    return data;
  };

  // Preparar datos para el gráfico de actividad diaria
  const prepareDailyChartData = () => {
    const sellers = Object.keys(groupedEventsBySellerAndHour);
    const days = [];
    
    // Crear array de días entre startDate y endDate
    const start = new Date(startDate);
    start.setHours(start.getHours() + 5); // Ajustar zona horaria
    const end = new Date(endDate);
    end.setHours(end.getHours() + 5); // Ajustar zona horaria
    
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      days.push(new Date(d));
    }

    return days.map(date => {
      const data = {
        fecha: FormatDateString(date),
        date: new Date(date)
      };

      sellers.forEach(sellerId => {
        const sellerData = groupedEventsBySellerAndHour[sellerId];
        let totalEvents = 0;
        
        // Buscar eventos para este día específico
        const dayKey = date.toISOString().split('T')[0];
        if (sellerData.days[dayKey]) {
          // Sumar todos los eventos de todas las horas de este día
          Object.values(sellerData.days[dayKey].hours).forEach(hourEvents => {
            totalEvents += hourEvents.length;
          });
        }
        
        data[sellerData.name] = totalEvents;
      });

      return data;
    });
  };

  const globalDefs = [
    {
      id: 'dots',
      type: 'patternDots',
      background: 'inherit',
      color: 'rgba(255, 255, 255, 0.3)',
      size: 4,
      padding: 1,
      stagger: true
    },
    {
      id: 'lines',
      type: 'patternLines',
      background: 'inherit',
      color: 'rgba(255, 255, 255, 0.3)',
      rotation: -45,
      lineWidth: 6,
      spacing: 10
    },
    {
      id: 'squares',
      type: 'patternSquares',
      background: 'inherit',
      color: 'rgba(255, 255, 255, 0.3)',
      rotation: 0,
      lineWidth: 50,
      spacing: 50
    }
  ]

  const chartTheme = {
    axis: {
      ticks: {
        text: {
          fill: "#666666",
          fontSize: 12
        }
      },
      legend: {
        text: {
          fill: "#666666",
          fontSize: 12
        }
      }
    },
    legends: {
      text: {
        fill: "#666666",
        fontSize: 12
      }
    }
  };


  return (
    <div className="flex flex-col h-screen w-full">
      
      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaClock className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Actividad trackeo de leads</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Vista:</span>
              <select
                value={view}
                onChange={(e) => setView(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="table">Tabla</option>
                <option value="chart">Gráfico</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder={`Buscar lead`}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Resumen de KPIs por trabajador */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8 py-1">
        <div className="flex flex-row justify-between w-full items-center gap-4 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center gap-4">
            {sellers.map(seller => (
              <span key={seller.id} className="flex items-center gap-2">
                <span className="text-xs text-gray-700 truncate">{seller.name}:</span>
                <span className={`text-xs font-bold truncate ${GetDynamicColor(workerKPIs[seller.id] || 0, ColorMapKPIs)}`}>
                  {(workerKPIs[seller.id] || 0).toFixed(1)}
                </span>
              </span>
            ))}
          </div>
          <div className="flex flex-row items-center gap-4">
            <span className="text-xs font-bold text-gray-700 truncate">
              Total eventos: <span className="text-gray-700 truncate">{events.length}</span>
            </span>
            <span className="text-xs font-bold text-gray-700 truncate">
              Puntaje global: <span className="text-gray-700 truncate">{Object.values(workerKPIs).reduce((acc, curr) => acc + curr, 0).toFixed(1)} pts</span>
            </span>
          </div>
        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row w-full justify-between overflow-x-auto gap-4 px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-between gap-4 px-4">

            {/* Vendedoras */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Vendedores:</span>
              <select
                value={selectedSeller}
                onChange={(e) => setSelectedSeller(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                {sellers.map((s) => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>

            {/* Filtro lead status */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Estado lead:</span>
              <select
                value={leadStatus}
                onChange={(e) => setLeadStatus(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                <option value="Lead">Lead</option>
                <option value="Prospecto">Prospecto</option>
                <option value="Cliente">Cliente</option>
              </select>
            </div>

            {/* Fechas */}
            <div className="flex flex-row gap-4 items-center justify-start w-full px-4">

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha inicio
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(startDate).toISOString().split('T')[0]}
                    onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha fin
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(endDate).toISOString().split('T')[0]}
                    onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

            </div>  

            
            {/* Tipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Tipo evento:</span>
              <select
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                <option value="Entrada al sistema">Entrada al sistema</option>
                <option value="Llamada">Llamada</option>
                <option value="Google Meet">Google Meet</option>
                <option value="Cambio estado cotización">Cambio estado cotización</option>
              </select>
            </div>

            {/* Subtipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Subtipo evento:</span>
              <select
                value={eventSubType}
                onChange={(e) => setEventSubType(e.target.value)}
                className="text-gray-700 min-w-[200px] hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                {eventType === "Entrada al sistema" && (
                  <option value="Entrada al sistema">Entrada al sistema</option>
                )}
                {eventType === "Llamada" && (
                  <>
                    <option value="Llamada perdida">Llamada perdida</option>
                    <option value="Llamada corta">Llamada corta</option>
                    <option value="Llamada fria">Llamada fria</option>
                    <option value="Llamada atendida">Llamada atendida</option>
                  </>
                )}
                {eventType === "Google Meet" && (
                  <>
                    <option value="Meet cancelado">Meet cancelado</option>
                    <option value="Meet reagendado">Meet reagendado</option>
                    <option value="Meet agendado">Meet agendado</option>
                    <option value="Meet atendido">Meet atendido</option>
                  </>
                )}
                {eventType === "Cambio estado cotización" && (
                  <>
                    <option value="Exito">Exito</option>
                    <option value="Evaluando opciones">Evaluando opciones</option>
                    <option value="Para el futuro">Para el futuro</option>
                    <option value="Frio">Frio</option>
                    <option value="Por confirmar depósito">Por confirmar depósito</option>
                    <option value="Curioso">Curioso</option>
                    <option value="No responde">No responde</option>
                    <option value="El servicio le parece caro">El servicio le parece caro</option>
                    <option value="Decidió trabajar con otra agencia">Decidió trabajar con otra agencia</option>
                    <option value="Decidió trabajar con un freelancer">Decidió trabajar con un freelancer</option>
                    <option value="No esta en mi ciudad">No esta en mi ciudad</option>
                    <option value="Competencia o sospechoso">Competencia o sospechoso</option>
                    <option value="Lead con poco presupuesto">Lead con poco presupuesto</option>
                  </>
                )}
              </select>
            </div>

          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <LoadingScreen />
          ) : (
            Object.keys(groupedEventsBySellerAndHour).length === 0 ? (
              <NoDataScreen />
            ) : (
              <div className="w-full">
                {view === "table" ? (
                  <table className="w-full text-xs">
                    <thead className="text-xs sticky top-0 z-50 text-gray-900 bg-gray-200 ">
                      <tr className="text-gray-700 text-center text-[10px] font-bold">
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Día
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Hora
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Vendedor
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Total eventos
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Llamadas perdidas
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Llamadas cortas
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Llamadas frias
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Llamadas atendidas
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Google Meets
                        </td>
                        <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                          Cambios estado cotización
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedCombinations.map(({ sellerId, sellerName, date, hour, events }) => {
                        const llamadasPerdidas = events.filter(e => e.eventSubType === "Llamada perdida").length;
                        const llamadasCortas = events.filter(e => e.eventSubType === "Llamada corta").length;
                        const llamadasFrias = events.filter(e => e.eventSubType === "Llamada fria").length;
                        const llamadasAtendidas = events.filter(e => e.eventSubType === "Llamada atendida").length;
                        const googleMeets = events.filter(e => e.eventType === "Google Meet").length;
                        const cambiosEstado = events.filter(e => e.eventType === "Cambio estado cotización").length;

                        return (
                          <tr 
                            key={`${sellerId}-${date.toISOString()}-${hour}`}
                            className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100"
                          >
                            <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                              {FormatDateString(date)}
                            </td>
                            <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                              {`${hour}:00`}
                            </td>
                            <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                              {sellerName}
                            </td>
                            <td className={`px-6 py-2 bg-slate-50 font-bold max-w-xs truncate border border-gray-300 text-center ${events.length > 0 ? "text-black" : "text-gray-200"}`}>
                              {events.length}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${llamadasPerdidas > 0 ? "text-black" : "text-gray-200"}`}>
                              {llamadasPerdidas}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${llamadasCortas > 0 ? "text-black" : "text-gray-200"}`}>
                              {llamadasCortas}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${llamadasFrias > 0 ? "text-black" : "text-gray-200"}`}>
                              {llamadasFrias}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${llamadasAtendidas > 0 ? "text-black" : "text-gray-200"}`}>
                              {llamadasAtendidas}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${googleMeets > 0 ? "text-black" : "text-gray-200"}`}>
                              {googleMeets}
                            </td>
                            <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${cambiosEstado > 0 ? "text-black" : "text-gray-200"}`}>
                              {cambiosEstado}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className="w-full p-4">

                    {/* 4 graficos */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                      {/* Eventos por hora por vendedora*/}
                      <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200" style={{ height: '600px' }}>
                        <div className="flex flex-row justify-between items-center">
                          <h3 className="text-xs font-semibold text-gray-700">Eventos por Hora</h3>
                          <div className="flex flex-row gap-2 items-center justify-center">
                            <span className="text-[10px] font-semibold text-gray-700">Mostrar 24 hrs</span>
                            <CheckBox
                              checked={showCompleteHours}
                              action={(checked) => setShowCompleteHours(checked)}
                            />
                          </div>
                        </div>
                        <ResponsiveBar
                          data={prepareChartData()}
                          keys={Object.keys(groupedEventsBySellerAndHour).map(id => groupedEventsBySellerAndHour[id].name)}
                          indexBy="hora"
                          margin={{ top: 50, right: 130, bottom: 80, left: 60 }}
                          padding={0.3}
                          valueScale={{ type: 'linear' }}
                          indexScale={{ type: 'band', round: true }}
                          colors={{ scheme: 'paired' }}
                          //groupMode="grouped"
                          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          axisTop={null}
                          axisRight={null}
                          defs={globalDefs}
                          fill={[
                            {
                                match: {
                                    id: 'Ventas 1'
                                },
                                id: 'dots'
                            },
                            {
                                match: {
                                    id: 'Marianne Gabriela'
                                },
                                id: 'lines'
                            },
                            {
                                match: {
                                    id: 'Micaela Norma'
                                },
                                id: 'squares'
                            },
                          ]}
                          axisBottom={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: -45,
                            legend: 'Hora del Día',
                            legendPosition: 'middle',
                            legendOffset: 48
                          }}
                          axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'Cantidad de Eventos',
                            legendPosition: 'middle',
                            legendOffset: -40
                          }}
                          labelSkipWidth={12}
                          labelSkipHeight={12}
                          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          legends={[
                            {
                              dataFrom: 'keys',
                              anchor: 'bottom-right',
                              direction: 'column',
                              justify: false,
                              translateX: 120,
                              translateY: 0,
                              itemsSpacing: 2,
                              itemWidth: 100,
                              itemHeight: 20,
                              itemDirection: 'left-to-right',
                              itemOpacity: 0.85,
                              symbolSize: 20,
                              effects: [
                                {
                                  on: 'hover',
                                  style: {
                                    itemOpacity: 1
                                  }
                                }
                              ]
                            }
                          ]}
                          theme={chartTheme}
                          animate={true}
                          motionConfig="gentle"
                        />
                      </div>

                      {/* Eventos por día por vendedora*/}
                      <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200" style={{ height: '600px' }}>
                        <h3 className="text-xs font-semibold text-gray-700">Eventos por Día de la Semana</h3>
                        <ResponsiveBar
                          data={prepareChartDataByDay()}
                          keys={Object.keys(groupedEventsBySellerAndHour).map(id => groupedEventsBySellerAndHour[id].name)}
                          indexBy="dia"
                          margin={{ top: 50, right: 130, bottom: 80, left: 60 }}
                          padding={0.3}
                          valueScale={{ type: 'linear' }}
                          indexScale={{ type: 'band', round: true }}
                          colors={{ scheme: 'paired' }}
                          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          axisTop={null}
                          axisRight={null}
                          defs={globalDefs}
                          fill={[
                            {
                                match: {
                                    id: 'Ventas 1'
                                },
                                id: 'dots'
                            },
                            {
                                match: {
                                    id: 'Marianne Gabriela'
                                },
                                id: 'lines'
                            },
                            {
                                match: {
                                    id: 'Micaela Norma'
                                },
                                id: 'squares'
                            },
                          ]}
                          axisBottom={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: -30,
                            legend: 'Día de la Semana',
                            legendPosition: 'middle',
                            legendOffset: 48
                          }}
                          axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'Cantidad de Eventos',
                            legendPosition: 'middle',
                            legendOffset: -40
                          }}
                          labelSkipWidth={12}
                          labelSkipHeight={12}
                          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          legends={[
                            {
                              dataFrom: 'keys',
                              anchor: 'bottom-right',
                              direction: 'column',
                              justify: false,
                              translateX: 120,
                              translateY: 0,
                              itemsSpacing: 2,
                              itemWidth: 100,
                              itemHeight: 20,
                              itemDirection: 'left-to-right',
                              itemOpacity: 0.85,
                              symbolSize: 20,
                              effects: [
                                {
                                  on: 'hover',
                                  style: {
                                    itemOpacity: 1
                                  }
                                }
                              ]
                            }
                          ]}
                          theme={chartTheme}
                          animate={true}
                          motionConfig="gentle"
                        />
                      </div>

                      {/* Eventos por tipo */}
                      <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200" style={{ height: '600px' }}>
                        <h3 className="text-xs font-semibold text-gray-700 mb-2">Eventos por Tipo</h3>
                        <ResponsivePie
                          data={preparePieData()}
                          margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                          innerRadius={0.5}
                          padAngle={0.7}
                          cornerRadius={3}
                          activeOuterRadiusOffset={8}
                          borderWidth={1}
                          colors={{ scheme: 'paired' }}
                          borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                          arcLinkLabelsSkipAngle={10}
                          arcLinkLabelsTextColor="#333333"
                          arcLinkLabelsThickness={2}
                          arcLinkLabelsColor={{ from: 'color' }}
                          arcLabelsSkipAngle={10}
                          arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                          defs={globalDefs}
                          fill={[
                              {
                                  match: {
                                      id: 'Llamada'
                                  },
                                  id: 'dots'
                              },
                              {
                                  match: {
                                      id: 'Google Meet'
                                  },
                                  id: 'lines'
                              },
                              {
                                  match: {
                                      id: 'Entrada al sistema'
                                  },
                                  id: 'squares'
                              },
                              {
                                  match: {
                                      id: 'Cambio estado cotización'
                                  },
                                  id: 'lines'
                              },
                          ]}
                          legends={[
                            {
                              anchor: 'bottom',
                              direction: 'row',
                              justify: false,
                              translateX: 0,
                              translateY: 56,
                              itemsSpacing: 10,
                              itemWidth: 120,
                              itemHeight: 18,
                              itemTextColor: '#999',
                              itemDirection: 'left-to-right',
                              itemOpacity: 1,
                              symbolSize: 18,
                              symbolShape: 'circle',
                              effects: [
                                {
                                  on: 'hover',
                                  style: {
                                    itemTextColor: '#000'
                                  }
                                }
                              ]
                            }
                          ]}
                          theme={chartTheme}
                        />
                      </div>
                      
                      {/* Eventos por tipo y subtipo */}
                      <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200" style={{ height: '600px' }}>
                        <h3 className="text-xs font-semibold text-gray-700 mb-2">Eventos por Tipo y Subtipo</h3>
                        <ResponsiveSunburst
                          data={prepareEventSubtypesData()}
                          margin={{ top: 40, right: 10, bottom: 40, left: 10 }}
                          id="id"
                          value="value"
                          cornerRadius={30}
                          innerRadius={0.1}
                          borderWidth={2}
                          // borderColor={{ from: 'color', modifiers: [['brighter', 10]] }}
                          colors={{ scheme: 'paired' }}
                          childColor={{ from: 'color', modifiers: [['brighter', 0.5]] }}
                          enableArcLabels={true}
                          arcLabel="id"
                          skipAngle={10}
                          arcLabelsSkipAngle={10}
                          arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                          legends={[
                            {
                              anchor: 'bottom',
                              direction: 'row',
                              justify: false,
                              translateX: 0,
                              translateY: 56,
                              itemsSpacing: 10,
                              itemWidth: 120,
                              itemHeight: 18,
                              itemTextColor: '#999',
                              itemDirection: 'left-to-right',
                              itemOpacity: 1,
                              symbolSize: 18,
                              symbolShape: 'circle',
                              effects: [
                                {
                                  on: 'hover',
                                  style: {
                                    itemTextColor: '#000'
                                  }
                                }
                              ]
                            }
                          ]}
                          theme={chartTheme}
                        />
                      </div>
                    </div>
                    
                    {/* Grafico de fechas */}
                    <div className="flex items-center justify-center w-full mt-4">
                      <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200 w-full" style={{ height: '600px' }}>
                        <div className="flex flex-row justify-between items-center">
                          <h3 className="text-xs font-semibold text-gray-700">Actividad por fecha</h3>
                        </div>
                        <ResponsiveBar
                          data={prepareDailyChartData()}
                          keys={Object.keys(groupedEventsBySellerAndHour).map(id => groupedEventsBySellerAndHour[id].name)}
                          indexBy="fecha"
                          margin={{ top: 50, right: 130, bottom: 80, left: 60 }}
                          padding={0.3}
                          valueScale={{ type: 'linear' }}
                          indexScale={{ type: 'band', round: true }}
                          colors={{ scheme: 'paired' }}
                          groupMode="stacked"
                          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          axisTop={null}
                          axisRight={null}
                          defs={globalDefs}
                          fill={[
                            {
                                match: {
                                    id: 'Ventas 1'
                                },
                                id: 'dots'
                            },
                            {
                                match: {
                                    id: 'Marianne Gabriela'
                                },
                                id: 'lines'
                            },
                            {
                                match: {
                                    id: 'Micaela Norma'
                                },
                                id: 'squares'
                            },
                          ]}
                          axisBottom={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: -45,
                            legend: 'Fecha',
                            legendPosition: 'middle',
                            legendOffset: 48
                          }}
                          axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'Cantidad de Eventos',
                            legendPosition: 'middle',
                            legendOffset: -40
                          }}
                          labelSkipWidth={12}
                          labelSkipHeight={12}
                          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                          legends={[
                            {
                              dataFrom: 'keys',
                              anchor: 'bottom-right',
                              direction: 'column',
                              justify: false,
                              translateX: 120,
                              translateY: 0,
                              itemsSpacing: 2,
                              itemWidth: 100,
                              itemHeight: 20,
                              itemDirection: 'left-to-right',
                              itemOpacity: 0.85,
                              symbolSize: 20,
                              effects: [
                                {
                                  on: 'hover',
                                  style: {
                                    itemOpacity: 1
                                  }
                                }
                              ]
                            }
                          ]}
                          theme={chartTheme}
                          animate={true}
                          motionConfig="gentle"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          )
        }
      </div>

    </div>
  )
}

export default DashboardActividadesComercialHora;
